function Slick() {
    var self = this;
	this.init();
}

Slick.prototype.init = function() {
	var self = this;
    $('body.-dweller .gallery-slick-wrapper').each(function() {
        self.createDwellerGalleries($(this));
    });
    $('body.-tourist .gallery-slick-wrapper').each(function() {
        self.createTouristGalleries($(this));
    });
    $('.services-list .square-index-slider').each(function(){
        self.createServicesSliders($(this));
    });
    $('.news-list .square-index-slider').each(function(){
        self.createNewsSliders($(this));
    });
    $('section.section--slideshow').each(function() {
        self.createArticleSlideshow($(this));
    });
    $('.section--cstudies-index-1 .cstudies-slick-wrapper').each(function(){
        if ($(this).find('.cstudies-index-item').length > 4) {
            self.createCstudiesSliders($(this));
        }
    });
    $('.section--walks-index .slick-wrapper, .section--places-index .slick-wrapper, .section--instagram .slick-wrapper').each(function(){
        if ($(this).find('.square-index-item').length > 4) {
            self.createWalksPlacesSliders($(this));
        }
    });
    $('.section--banners .slick-wrapper').each(function(){
        self.createBannerSlider($(this));
    });
};

Slick.prototype.createDwellerGalleries = function(slider) {
    var self = this;

    var slideInfo = $(slider).closest('.gallery-container').siblings('.gallery-footer').find('.gallery-footer-description');
    var index = $(slider).closest('.gallery-container').siblings('.gallery-footer').find('.gallery-footer-counter span');

    $(slider).on('init', function() {
        var slideCount = $(slider).find('.slick-slide:not(.slick-cloned)').length;
        // slideInfo.text($(slider).find("[data-slick-index='0']").find('.slick-description').text());
    });

    $(slider).slick({
        slidesToShow: 1,
        infinite: true,
        centerMode: false,
        variableWidth: true,
        // adaptiveHeight: true,
        // waitForAnimate: false,
        fade: false,
        arrows: true,
        speed: 300,
        prevArrow: $(slider).closest('.gallery-container').siblings('.gallery-footer').find('.gallery-footer-nav').find('.gallery-footer-nav-arrow.-left'),
        nextArrow: $(slider).closest('.gallery-container').siblings('.gallery-footer').find('.gallery-footer-nav').find('.gallery-footer-nav-arrow.-right'),
        dots: false,
        autoplay: false,
    });

    $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var slideText = $(slick.$slides.get(nextSlide)).find('.slick-description').text();
        if (!slideInfo.hasClass('-fade')){
            slideInfo.addClass('-fade');
            setTimeout(function(){
                slideInfo.removeClass('-fade');
                slideInfo.text(slideText);
            }, 300);
        }
    });

    $(slider).on('reInit afterChange', function(event, slick, currentSlide, nextSlide){
        var slideCount = $(slider).find('.slick-slide:not(.slick-cloned)').length;
        var i = (currentSlide ? currentSlide : 0) + 1;
        index.text(i);
    });
};

Slick.prototype.createTouristGalleries = function(slider) {
    var self = this;

    $(slider).on('init', function() {
        var slideCount = $(slider).find('.slick-slide:not(.slick-cloned)').length;
        // slideInfo.text($(slider).find("[data-slick-index='0']").find('.slick-description').text());
    });

    $(slider).slick({
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        adaptiveHeight: false,
        // waitForAnimate: false,
        fade: false,
        arrows: true,
        speed: 300,
        prevArrow: $(slider).closest('.gallery-container').find('.gallery-footer-nav').find('.gallery-footer-nav-arrow.-left'),
        nextArrow: $(slider).closest('.gallery-container').find('.gallery-footer-nav').find('.gallery-footer-nav-arrow.-right'),
        dots: true,
        autoplay: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    centerMode: false,
                },
            }
        ],
    });
};

Slick.prototype.createServicesSliders = function(slider) {
    var self = this;

    $(slider).slick({
        infinite: false,
        autoplay: false,
        accessibility: false,
        swipe: true,
        verticalSwipe: false,
        swipeToSlide: true,
        mobileFirst: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        centerMode: false,
        variableWidth: false,
        adaptiveHeight: false,
        waitForAnimate: false,
        fade: false,
        arrows: true,
        // cssEase: 'cubic-bezier(0,0,0,1)',
        dots: true,
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick',
            },
            {
                breakpoint: 1259,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
        ]
    });
};

Slick.prototype.createNewsSliders = function(slider) {
    var self = this;

    $(slider).slick({
        infinite: true,
        mobileFirst: false,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        fade: false,
        arrows: true,
        dots: true,
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick',
            },
            {
                breakpoint: 1259,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
};

Slick.prototype.createArticleSlideshow = function(slider) {
    var self = this;
    let count = slider.find('> section').length;

    slider.find('> section').each(function(index, element) {
        $(element).find('.text-container').addClass('text-container--slideshow').append('<div class="slideshow-navigaton"><img src="/images/ui/gallery_arrow.svg"><span>'+(index+1)+'&nbsp;/&nbsp;'+count+'</span><img src="/images/ui/gallery_arrow.svg"></div>');
    });

    $(slider).slick({
        infinite: true,
        mobileFirst: false,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: false,
        fade: true,
        arrows: false,
        dots: false,
        responsive: []
    });

    slider.find('section').each(function(index, element) {
        $(element).find('.slideshow-navigaton img:first-child').on('click', function() {
            $(slider).slick('slickPrev');
        });
        $(element).find('.slideshow-navigaton img:last-child').on('click', function() {
            $(slider).slick('slickNext');
        });
    });
};

Slick.prototype.createCstudiesSliders = function(slider) {
    var self = this,
        responsive = [];

    if ($(slider).closest('.section--cstudies').hasClass('section--cstudies-index-1')) {
        if (slider.hasClass('cstudies-slick-wrapper--list')) {
            responsive = [
                {
                    breakpoint: 479,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
            ];
        } else {
            responsive = [
                {
                    breakpoint: 479,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
            ];
        }
    } else {
        responsive = [
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 1279,
                settings: 'unslick',
            },
        ];
    }

    $(slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        centerMode: false,
        variableWidth: false,
        mobileFirst: true,
        // adaptiveHeight: true,
        // waitForAnimate: false,
        fade: false,
        arrows: true,
        speed: 300,
        prevArrow: $(slider).closest('.section--cstudies').find('.slick-nav').find('.slick-nav-arrow.-left'),
        nextArrow: $(slider).closest('.section--cstudies').find('.slick-nav').find('.slick-nav-arrow.-right'),
        dots: true,
        autoplay: false,
        responsive: responsive,
    });
};

Slick.prototype.createWalksPlacesSliders = function(slider) {
    var self = this,
        responsive = [
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 1279,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
        ];

    $(slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        centerMode: false,
        variableWidth: false,
        mobileFirst: true,
        // adaptiveHeight: true,
        // waitForAnimate: false,
        fade: false,
        arrows: true,
        speed: 300,
        prevArrow: $(slider).closest('.section').find('.slick-nav').find('.slick-nav-arrow.-left'),
        nextArrow: $(slider).closest('.section').find('.slick-nav').find('.slick-nav-arrow.-right'),
        dots: true,
        autoplay: false,
        responsive: responsive,
    });
};

Slick.prototype.createBannerSlider = function(slider) {
    var self = this;
    var parent = $(slider).closest('.section--banners');
    $(slider).slick({
        slidesToShow: 1,
        infinite: true,
        centerMode: false,
        variableWidth: false,
        fade: true,
        arrows: false,
        speed: 1000,
        dots: false,
        autoplay: true,
        autoplaySpeed: 7000,
    });
    $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        parent.find('h1 span').addClass('-fade');
    });
    $(slider).on('afterChange', function(event, slick, currentSlide) {
        var slideLink = $(slick.$slides.get(currentSlide)).attr('data-href');
        var slideText = $(slick.$slides.get(currentSlide)).attr('data-title');
        parent.find('h1 a').attr('href', slideLink);
        parent.find('h1 span').text(slideText).removeClass('-fade');
    });
};